/**
 * @module ol/functions
 */

/**
 * Always returns true.
 * @returns {boolean} true.
 */
export function TRUE() {
  return true;
}

/**
 * Always returns false.
 * @returns {boolean} false.
 */
export function FALSE() {
  return false;
}

/**
 * A reusable function, used e.g. as a default for callbacks.
 *
 * @return {void} Nothing.
 */
export function VOID() {}

//# sourceMappingURL=functions.js.map


// WEBPACK FOOTER //
// ./~/ol/functions.js